/**
 * Phase of an in-flight elicitation submit. Used by indicator components
 * to switch copy between "Submitting response..." (during the POST) and
 * "Alby is thinking..." (POST resolved, awaiting the resumed stream's
 * first chunks). The streaming indicator "Alby is responding..." takes
 * over once the AI SDK status flips to `streaming`.
 *
 * Lives in its own file so consumers (including the unit test for the
 * assistant message footer) can import the enum without pulling in
 * `use-mcp-chat`'s transitive dep on `@ai-sdk/react`, which references
 * `TransformStream` and breaks in jsdom.
 */
export enum ElicitationSubmitPhase {
  Idle = "idle",
  Posting = "posting",
  WaitingForStream = "waiting-for-stream",
}
